<template>
  <div v-if="errors.detail" class="mb-6 pb-3 border-b">
    <div class="text-red-default font-semibold">{{ $t(`mygwf.components.FormError.correct_errors`) }}</div>
    <div v-if="typeof errors.detail === 'string' && errors.detail !== null">&#8226; {{ text(errors.detail) }}</div>
    <ul v-else v-for="(detail, key) in errors.detail" :key="key">
      <span v-if="typeof detail === 'string' && detail !== null">&#8226; {{ text(detail) }}</span>
      <li v-else v-for="(desc, i) in detail" :key="i" class="font-semibold">
        &#8226; <span class="capitalize">{{ label(key) }}</span> - {{ text(desc) }}
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  methods: {
    text(error) {
      if (typeof error === 'object') {
        return error
      }
      const msg = error
        .split(' ')
        .join('_')
        .split('.')
        .join('')
        .toLowerCase()
      return this.$te(`mygwf.components.FormError.${msg}`) ? this.$t(`mygwf.components.FormError.${msg}`) : error
    },
    label(key) {
      return this.$te(`mygwf.components.Label.${key}`) ? this.$t(`mygwf.components.Label.${key}`) : key
    },
  },
  props: {
    errors: {
      type: [Array, Object],
      default: function() {
        return {}
      },
    },
  },
}
</script>
